export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">关于我们</h2>
          <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            <p>
              每日爆料成立于2024年，是国内领先的UGC爆料内容聚合平台。我们致力于打造一个开放、透明、可信的爆料信息共享社区，
              让每一个普通人都能成为真相的发现者和传播者。
            </p>
            <p>
              平台核心产品「每日爆料大赛」以赛事排名的形式激励优质爆料内容创作，通过热度、讨论度、可信度等多维度指标，
              对参赛作品进行公平排序展示。每一条爆料都经过社区交叉验证与编辑审核，确保内容质量与信息可信度。
            </p>
            <p>
              目前平台已覆盖娱乐、科技、消费、房产、教育、出行等20+领域，日均活跃用户超过18万，累计爆料作品超过50万条。
              我们相信，信息的力量在于真实，而真实来源于每一个勇于发声的你。
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-6 mt-8">
            <div className="text-center">
              <div className="font-heading text-3xl font-bold text-primary-500">50万+</div>
              <div className="text-xs text-foreground-500 mt-1">累计爆料</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-3xl font-bold text-primary-500">20+</div>
              <div className="text-xs text-foreground-500 mt-1">覆盖领域</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-3xl font-bold text-primary-500">365天</div>
              <div className="text-xs text-foreground-500 mt-1">全年无休更新</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}